module.exports = __webpack_public_path__ + "static/media/user-icon.b0c81965.svg";